<template>
  <div style="width: 100%;height: 100%;padding:10px;box-sizing: border-box"
       @click="clickHandler"
       :style="{border: option.attribute.border.show ? `${option.attribute.border.width}px  ${option.attribute.border.lineType} ${option.attribute.border.color}` : 'none',borderRadius:option.attribute.border.radius+'px'}">
    <div style="width: 100%;display: flex;height: calc(100% - 20px)">
      <div style="flex: 2">
        <div style="width: 100%;height: 100%;">
          <div :style="{width:(height - 46) + 'px',height:(height - 46) + 'px'}" style="margin: 0 auto;position: relative">
            <img style="width: 100%;height: 100%;" v-if="option.attribute.icon.show" :src="fileUrl+option.attribute.icon.url"
                 :style="option.attribute.icon.autoRotate ? {animation:'rotate 2s infinite linear'} : {}">
            <div style="position:absolute;left: 0;top: 0;height: 100%;width: 100%;text-align: center;font-size: 13px;" v-show="option.attribute.value.position === 'icon'"
                 :style="{lineHeight: (height - 46) + 'px',color:option.attribute.value.color}">{{percentage}}%</div>
          </div>
        </div>
      </div>
      <div style="flex: 3">
        <div style="display: flex;padding-top: 2px" :style="{lineHeight:option.attribute.value.fontSize+'px'}">
          <div style="flex: 1" :style="{color:option.attribute.label.color,fontSize:option.attribute.label.fontSize+'px'}">{{option.attribute.label.valueLabel}}</div>
          <div style="flex: 1" :style="{color:option.attribute.value.color,fontSize:option.attribute.value.fontSize+'px',fontFamily:option.attribute.value.fontFamily}">
            {{cptData.value}}
          </div>
        </div>
        <div style="display: flex" :style="{lineHeight:((height - 40) / 2) + 'px'}">
          <div style="flex: 1" :style="{color:option.attribute.label.color,fontSize:option.attribute.label.fontSize+'px'}">{{option.attribute.label.totalLabel}}</div>
          <div style="flex: 1" :style="{color:option.attribute.value.color,fontSize:option.attribute.value.fontSize+'px',fontFamily:option.attribute.value.fontFamily}">
            {{cptData.total}}
          </div>
        </div>
      </div>
    </div>
    <div :style="{marginTop:option.attribute.value.position === 'progress' ? '0px':'10px'}">
      <t-progress status="active" :percentage="percentage" :color="{ from:option.attribute.progress.color[0],to:option.attribute.progress.color[1]}"
                  :trackColor="option.attribute.progress.bgColor" :size="option.attribute.progress.size" :label="option.attribute.value.position === 'progress'"/>
    </div>
  </div>
</template>

<script>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {fileUrl} from '/env'
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-quota-progress",
  props: {
    option: Object,
    height: Number,
    components: Array, current: Object
  },
  // mixins: [mixinsCom], 
  data() {
    return {
      fileUrl,
      cptData: {},
      percentage:0,
      uuid: null,
      newData:"",
      jsFunFlag:false,
    }
  },
  computed:{
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    'option.attribute': {
      handler(obj) {
         this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {

        this.refreshCptData();
      
    }
    
    this.refreshCptData(this.option.cptDataForm);
  },
  methods:{
    refreshCptData(cptDataForm = this.option.cptDataForm,paras) {
      pollingRefresh(this.uuid, cptDataForm, ()=>this.loadData(cptDataForm,paras),this.components)
    },
    loadData(cptDataForm,paras) {
      const that = this;
      getDataJson(cptDataForm,paras,(res)=> {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        // that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm,that.newData,that.jsFunFlag);  // //监听里面会执行的
        // this.cptData = res;
        // let pa = Math.round(res.value/res.total*1000)/10
        // this.percentage = pa % 1 === 0 ? Math.floor(pa):pa
        })
    },
    processData(cptDataForm,res,jsFunFlag,isFromGrid){
      let val =''
      // 第一层判断 如果选择数据集
      if(cptDataForm.dataSource == '4') {
            // if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        // if(jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据
            if(hasNonEmptyValues(this.option.attribute.cptTableData)) {  
              const dataKey = this.option.attribute.cptTableData;
              // 创建一个新的数组用于存储结果
              let newres = [];
              let newObj = {...res[0]};
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
              dataKey.forEach(item => {
                newObj[item.namekey] = newObj[item.value];
              });
              newres.push(newObj);
              // console.log(newres,'新数组')
              val = newres[0];
           }
          // } else { // 如果配置了转换脚本
          //   this.cptData = res;
          // }
       } else { // 不是数据集类型，是静态数据
           val =   res;
       } 
        let pa = Math.round(this.cptData.value/this.cptData.total*1000)/10;
        this.percentage = pa % 1 === 0 ? Math.floor(pa):pa;
        return val
    },
    clickHandler(){
      // this.$emit("clickHandler",this.option.interaction, "default", this.option.attribute.valueLabel,'cpt-quota-progress')
      this.$emit("clickHandler",this.option.interaction, "default", this.cptData,'cpt-quota-progress')
    }
  }
}
</script>

<style>
@keyframes rotate{
  to{ transform:rotate(360deg)}
}
</style>
